<template>
<div>

<template v-if="$store.state.auth.userroles.includes('supplier')">
<ContentHeader v-if="data"  :title="flowname"  :show_button="true"  icon="arrow-left" buttontype="danger" :label="$store.state.languages.lang_phrases.geri_don" url="SupplierBrandProject" :urlparams="headerurlparams"></ContentHeader>
</template>

<template v-else>
<ContentHeader v-if="data"  :title="data.flowsupplier.flow.name"  :show_button="true"  icon="arrow-left" buttontype="danger" label="Geri" url="SupplierProject" :urlparams="headerurlparams"></ContentHeader>
</template>


<div class="content_card" >
<div class="grid">

<div class="col-12">

<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>

<div class="content_card_content" v-if="!loading">



<div class="grid" >

<div class="col-3 md:col-8"><h4 class="text-primary mt-4">{{$store.state.languages.lang_phrases.marka_bildirisi}}:</h4></div>
<div class="col-9 md:col-4">
<Button type="button"  :label="$store.state.languages.lang_phrases.goruntulemek_icin_tiklayin" @click="showFlowInfo" icon="pi pi-eye"  class="p-button-primary p-button-outlined p-button-sm mr-2 mt-3"   />
</div>
<div class="col-12"><hr></div>
</div>





<!-- if not audit -->
<div class="grid" v-if="data.flowsupplier.flow.type!=='audit'">

<div class="col-12 md:col-8">
<h4 class="text-primary mt-0">{{$store.state.languages.lang_phrases.asama_ozeti}}</h4>

<template v-if="data.flowsupplier.flow.type=='education'">

<p class="text-red-600 font-bold" v-if="data.flowsupplier.status !=='finished'">{{$store.state.languages.lang_phrases.asama_henuz_tamamlanmadi}}</p>
<p class="text-green-600 font-bold" v-else>{{$store.state.languages.lang_phrases.asama_tamamlandi}}</p>

</template>

<template v-else>


<template v-if="data.quizresult">


<template v-if="data.flowsupplier.flow.type=='audit'">
  <template v-if="data.flowsupplier.audit && data.flowsupplier.audit.status=='finished'">
    <QuizpointModule :data="data" />
  </template> 
  <template v-if="data.flowsupplier.audit && data.flowsupplier.audit.status=='under_review'">
    <small class="text-green-500 font-bold">{{$store.state.languages.lang_phrases.teknik_denetlemede}}</small>
  </template> 
</template>


<template v-if="data.flowsupplier.flow.type=='verification'">
  <template v-if="data.flowsupplier.verification && data.flowsupplier.status=='finished'">
    <QuizpointModule :data="data" />
  </template> 
  <template v-if="data.flowsupplier.verification && data.flowsupplier.verification.status=='under_review'">
    <small class="text-green-500 font-bold">{{$store.state.languages.lang_phrases.teknik_denetlemede}}</small>
  </template>  
</template>

<template v-if="data.flowsupplier.flow.type=='self_evaluation' && data.flowsupplier.quizresult">
  <QuizpointModule :data="data" /> 
</template>






<div class="grid" v-if="!data.flowsupplier.flow.questionlist.calculate_points">
<div class="col-12">
<p class="text-green-500 font-bold mt-0">{{$store.state.languages.lang_phrases.bu_asama_icin_puanlama_bulunmuyor}}</p>
</div>
</div>









</template>


<template v-else>
  <p class="text-red-600 font-bold">{{$store.state.languages.lang_phrases.asama_henuz_tamamlanmadi}}</p>
</template>
</template>


</div>



<div class="col-12 md:col-4">
<Button :label="$store.state.languages.lang_phrases.goster"  class="p-button-white  p-button-sm rightmargin mt-4" @click="gotoActiveFlow(data.flowsupplier.uuid)" ></Button>
</div>
<div class="col-12">
  <hr>
</div>



</div>

<!-- if not audit -->

<!-- if audit -->
<div class="grid" v-if="data.flowsupplier.flow.type=='audit'">
<div class="col-12 md:col-8">
<h4 class="text-primary mt-0">{{$store.state.languages.lang_phrases.asama_ozeti}}</h4>
 <template v-if="data.flowsupplier.audit.status=='finished' && data.flowsupplier.quizresult">
  <QuizpointModule :data="data" />
</template>
</div>


<div class="col-12 md:col-4">
<!-- if audit planned-->
<template v-if="data.flowsupplier.audit">


  <template v-if="data.flowsupplier.status=='started'">
    <small class="text-green-500 font-bold">{{$store.state.languages.lang_phrases.denetleme_devam_ediyor}}</small>
  </template>  

  <template v-if="data.flowsupplier.status=='created' || data.flowsupplier.status=='finished'">
    <Button :label="$store.state.languages.lang_phrases.goster"  class="p-button-white  p-button-sm rightmargin mt-0" @click="goToAuditSummary(data.flowsupplier.uuid)" ></Button>
  </template>

  <template v-if="data.flowsupplier.audit.status=='under_review'">
    <small class="text-green-500 font-bold">{{$store.state.languages.lang_phrases.teknik_denetlemede}}</small>
  </template>
  
  <template v-if="is_audit_date">
    <br/><br/>
   <small class="text-green-500 font-bold" v-if="is_audit_date!=='before'">{{$store.state.languages.lang_phrases.oturum_tarihi}}: {{$filters.momentFormat(data.flowsupplier.audit.scheduled_at,"DD-MM-YYYY   hh:mm")}} </small>
  </template>

  <template v-if="!is_audit_date">
    <br/><br/>
     <small class="text-green-500 font-bold">{{$store.state.languages.lang_phrases.planlamada}}</small>
  </template>

</template>
<!-- if audit planned-->
<!-- if audit not planned-->
<template v-else>
  <p class="text-green-500 font-bold mt-0">{{$store.state.languages.lang_phrases.planlama_bekliyor}}</p>

</template>
<!-- if audit not planned-->
<!--<Button :label="$store.state.languages.lang_phrases.goster"  class="p-button-white  p-button-sm rightmargin mt-4" @click="goToAuditSummary(data.flowsupplier.uuid)" ></Button>-->
</div>
<div class="col-12">
  <hr>
</div>

<template v-if="data.flowsupplier.audit.status=='finished' && data.quizresult && data.quizresult.questionlist.multiple_calculations && data.flowsupplier.customquizresults.length">

<div class="col-12">
  <h4 class="text-primary">{{$store.state.languages.lang_phrases.soru_sinifi_hesaplamalari}}</h4>
</div>

<div class="col-12">
  <Accordion multiple>
    <AccordionTab v-for="result in data.flowsupplier.customquizresults" :header="result.calculation.name">
      <div class="grid" >
        <div class="col-2">
        <p class="font-bold mt-0">{{$store.state.languages.lang_phrases.puan}}:</p>
        </div>
        <div class="col-10">
          <p class="text-primary mt-0">{{result.points.toFixed(2)}}</p>
        </div>
        <template v-if="result.calculation.customattribute && result.calculation.customattribute.supplierattributes.length">
          <div class="col-2">
          <p class="font-bold mt-0">{{getTheTranslation(result.calculation.customattribute,"translation")}}:</p>
          </div>
          <div class="col-10">
            <template v-if="result.calculation.customattribute.type=='select'">
              <p class="mt-0 font-bold" v-html="getOptionData(result.calculation.customattribute.options,result.calculation.customattribute.supplierattributes[0].attibutenumericalval)"></p>
            </template>
          </div>          
        </template>
      </div>
  </AccordionTab>
  </Accordion>
</div> 

</template>
</div>
<!-- if audit -->

<div class="grid" >
<SupplierBrandFlowSummaryForAttributes  :flowsupplierattributes="flowsupplierattributes" />
</div>

<template v-if="data.flowsupplier.flow.type=='audit' && data.flowsupplier.audit">
  
  <SupplierBrandFlowSummaryForAudit 
    v-if="data.flowsupplier.audit"
    :requiredcertificates="requiredcertificates" 
    :exemptioncertificates="exemptioncertificates" 
    :flowsupplier="data.flowsupplier"
    @fileReadyToUpload="uploadFile"
    :nonconformities="nonconformities"
    :nonconformity_types="nonconformity_types"
    ></SupplierBrandFlowSummaryForAudit>
</template>




<template v-if="data.flowsupplier.flow.type=='verification' && data.flowsupplier.verification && data.flowsupplier.status=='finished'">

<SupplierBrandFlowSummaryForVerification 
:flowsupplier="data.flowsupplier"
:nonconformities="nonconformities"
@fileReadyToUpload="uploadFile"
:nonconformity_types="nonconformity_types"
></SupplierBrandFlowSummaryForVerification>
</template>





</div>



</div>
</div>
</div>




<Dialog :header="flowname + ' '+$store.state.languages.lang_phrases.marka_bildirisi" v-model:visible="show_flow_info" :breakpoints="{'960px': '75vw', '640px': '90vw'}" :style="{width: '80vw'}" :modal="true">
<ScrollPanel style="width: 100%; height: 500px">
<div v-html="welcometext"></div>
</ScrollPanel>
</Dialog>






</div>


</template>

<script>
import SupplierBrandFlowSummaryForAudit  from "./SupplierBrandFlowSummaryForAudit"
import SupplierBrandFlowSummaryForEducation  from "./SupplierBrandFlowSummaryForEducation"
import SupplierBrandFlowSummaryForSelfEvaluation  from "./SupplierBrandFlowSummaryForSelfEvaluation"
import SupplierBrandFlowSummaryForVerification  from "./SupplierBrandFlowSummaryForVerification"
import SupplierBrandFlowSummaryForAttributes  from "./SupplierBrandFlowSummaryForAttributes"


import QuizpointModule from "./QuizpointModule"
import moment from "moment"
export default {

  name: 'SupplierBrandFlowSummary',

  data () {
    return {
    	data:null,
    	loading:true,
      requiredcertificates:[],
      exemptioncertificates:[],
      show_flow_info:false,
      nonconformities:[],
      nonconformity_types:[],
    }
  },
  components:{
    SupplierBrandFlowSummaryForAudit,
    SupplierBrandFlowSummaryForEducation,
    SupplierBrandFlowSummaryForSelfEvaluation,
    SupplierBrandFlowSummaryForVerification,
    SupplierBrandFlowSummaryForAttributes,
    QuizpointModule,
  },
  computed:{
    flowsupplierattributes()
    {
      if(this.data.flowsupplier && this.data.flowsupplier.flow.flowattributes.length)
      {
        let result = []
        for(let item of this.data.flowsupplier.flow.flowattributes)
        {
          let custom_attribute_id = item.customattribute_id
          let ind = this.data.flowsupplier.supplierattributeversions.findIndex(element =>element.customattribute_id == custom_attribute_id)
          if(ind!==-1)
          {            
            item.customattribute.supplierattributes[0].attibutenumericalval = this.data.flowsupplier.supplierattributeversions[ind].attibutenumericalval
            item.customattribute.supplierattributes[0].attibutetextval = this.data.flowsupplier.supplierattributeversions[ind].attibutetextval
          }
          console.log(item)
          result.push(item)
        }
        return result
      }
      return []
    },
    is_audit_date()
    {
      
      if(this.data.flowsupplier.flow.type=='audit' && this.data.flowsupplier.audit && this.data.flowsupplier.audit.scheduled_at)
      {
        let scheduled_at = moment(this.data.flowsupplier.audit.scheduled_at)
        let now = moment()
        if(now.isSame(scheduled_at, 'day'))
        {
          return "today"
        }
        if(moment(scheduled_at).isAfter(now, 'day'))
        {
          return "after"
        }
        if(moment(scheduled_at).isBefore(now, 'day'))
        {
          return "before"
        }

      }
      return null
    },
    flowname()
    {
      let preflang = this.$store.state.auth.user.preflang
      if(this.data)
      {
        if(this.data.flowsupplier.flow.translations.length)
        {
          let text = this.data.flowsupplier.flow.translations.find((item)=>{return item.language_id == preflang.id})
          if(text)
          {
            return text.translation 
          }
          else
          {
            return this.data.flowsupplier.flow.name
          }
          
        }
        else
        {
          return this.data.flowsupplier.flow.name
        }
        
      }

      return ""
    },
    welcometext()
    {
      let preflang = this.$store.state.auth.user.preflang
      if(this.data)
      {
        let text = this.data.flowsupplier.flow.translations.find((item)=>{return item.language_id == preflang.id})
        if(text && text.description)
        {
          return text.description
        }
        else
        {
          
          return "<p><b>"+this.$store.state.languages.lang_phrases.ozel_bir_bildirim_bulunmuyor+"</b></</p>"
        }
        
      }

      return "<p><b>"+this.$store.state.languages.lang_phrases.ozel_bir_bildirim_bulunmuyor+"</b></</p>"
    },
    headerurlparams()
    {
      return {project_id:this.$route.params.project_id}
    },
    header()
    {
      if(this.data)
      {
        return this.data.flow.name
      }
      return ""
    }
  },
  mounted()
  {
    this.$store.dispatch('ui/setActiveTab',"projeler") 
  	this.getData()
  },
  methods:{
    getOptionData(options,id)
    {
      let item = options.find(item=>item.id == id)
      if(item)
      {
        if(item.color)
        {
          return "<span style='color:#"+item.color+"'>"+this.getTheTranslation(item,"translation")+"</span>"
        }
        else
        {
          return "<span class='text-primary'>"+this.getTheTranslation(item,"translation")+"</span>"
        }
      }
      return null
    },
    showFlowInfo()
    {
      this.show_flow_info = true
    },
    getattributeName(attribute)
    {
      if(attribute.translations && attribute.translations.length)
      {
        let translation = attribute.translations.find((element)=>{return element.language_id ==  this.$store.state.auth.user.preflang_id})
        if(translation)
        {
          return translation.translation
        }
        else
        {
          attribute.name
        }
      }
      else
      {
        return attribute.name
      }
    },
    uploadFile(data)
    {
      let formdata = new FormData()

      for( var i = 0; i < data.files.length; i++ )
      {
          let file =  data.files[i];
          formdata.append('files[' + i + ']', file);
      }
      formdata.append("certification_body",data.certification_body)
      formdata.append("valid_through",moment(data.valid_through).format("YYYY-MM-Do"))
      formdata.append("certificatetype_id",data.certificatetype_id)
      formdata.append("flowsupplier_id",this.data.flowsupplier.id)
      this.generalSubmission(formdata,"audit/submitsupplier_certificate",this.afteruploadFile)
    },
    afteruploadFile(response)
    {
      this.data.uploaded_certificates = response.data
      this.resolveUploadedCertificates()
    },
    resolveUploadedCertificates()
    {
      let uploaded_certificates = this.data.uploaded_certificates
      let requiredcertificates = this.requiredcertificates
      let exemptioncertificates = this.exemptioncertificates


      for(let requiredcertificate of requiredcertificates)
      {
        requiredcertificate.documents = []
        requiredcertificate.upload_status = 0
      }

      for(let exemptioncertificate of exemptioncertificates)
      {
        exemptioncertificate.documents = []
        exemptioncertificate.upload_status = 0
      }

      for(let uploaded_certificate of uploaded_certificates)
      {
        let exampmatch = exemptioncertificates.findIndex((item)=>{return item.certificatetype_id == uploaded_certificate.certificatetype_id})
        if(exampmatch!==-1)
        {
          exemptioncertificates[exampmatch].documents.push(uploaded_certificate)
        }

        let reqmatch = requiredcertificates.findIndex((item)=>{return item.certificatetype_id == uploaded_certificate.certificatetype_id})
        if(reqmatch!==-1)
        {
          requiredcertificates[reqmatch].documents.push(uploaded_certificate)
        }

      }

      for (let i = 0; i < requiredcertificates.length; i++)
      {
        for (let ii = 0; ii < requiredcertificates[i].documents.length; ii++)
        {
          if(requiredcertificates[i].documents[ii].status=="accepted")
          {
            requiredcertificates[i].upload_status = 1            
          }
        }
        
      }

      for (let i = 0; i < exemptioncertificates.length; i++)
      {
        for (let ii = 0; ii < exemptioncertificates[i].documents.length; ii++)
        {
          if(exemptioncertificates[i].documents[ii].status=="accepted")
          {
            exemptioncertificates[i].upload_status = 1            
          }
        }
      }

      this.requiredcertificates = requiredcertificates
      this.exemptioncertificates = exemptioncertificates

    },
  	async getData()
  	{
  		this.loading = await true
     	this.data = await this.generalApiGetWithoutLoader("audit/get_flow_summary_data/"+this.$route.params.flow_id) 
     	console.log(this.data)
      await this.$store.dispatch('evaluation/setMode',"viewing")
      await this.$store.dispatch('evaluation/setEvaluation',this.data.flowsupplier) 

      /*
      let supplierattributes = this.data.flowsupplier.supplier.supplierattributes
      for(let flowattribute of this.data.flowsupplier.flow.flowattributes)
      {
        let the_att = await supplierattributes.find((item)=>{return item.customattribute_id == flowattribute.customattribute_id})
        if(the_att)
        {
          await this.flowsupplierattributes.push(the_att)
        }
        
      }
      */
      
      let requiredcertificates = await []
      let exemptioncertificates = await []
      this.nonconformities = this.data.nonconformities
      this.nonconformity_types = this.data.nonconformity_types
      //loop auditdays
      
      //loop requiredcertificates
      for(let requiredcertificate of this.data.flowsupplier.flow.requiredcertificates)
      {
        let element = await requiredcertificates.findIndex((item)=>{return item.certificatetype_id == requiredcertificate.certificatetype_id})
        if(element==-1)
        {
          await requiredcertificates.push(requiredcertificate)
        }
      }
      //loop requiredcertificates

      //loop exemptioncertificate
      for(let exemptioncertificate of this.data.flowsupplier.flow.exemptioncertificates)
      {
        let element = await exemptioncertificates.findIndex((item)=>{return item.certificatetype_id == exemptioncertificate.certificatetype_id})
        if(element==-1)
        {
          await exemptioncertificates.push(exemptioncertificate)
        }
      }
      //loop exemptioncertificate

      
      

      for(let requiredcertificate of requiredcertificates)
      {
        let element = await exemptioncertificates.find((item)=>{return item.certificatetype_id == requiredcertificate.certificatetype_id })
        
        if(element)
        {
          requiredcertificates = await requiredcertificates.filter((item)=>{return item.certificatetype_id !== element.certificatetype_id})
        }
      }

      this.exemptioncertificates = await exemptioncertificates
      this.requiredcertificates = await requiredcertificates

      await this.resolveUploadedCertificates()


      this.loading = await false
  	},
    goToAuditSummary()
    {
      this.$router.push({ name: 'AuditCover', params: { audit_uuid:this.data.flowsupplier.audit.uuid } })
    },
    gotoActiveFlow(uuid)
    {             
      this.$router.push({ name: 'Evaluation', params: { id:uuid } })
    },
  }
}
</script>

<style lang="css" scoped>
</style>